//* 按需导入插件
import { gsap } from "gsap";

//* 组件属性
import type { AIStatementProps } from "../index";
import type { UiModal, UiForm, UiTypes } from "various-ui";

import { $message } from "various-ui";

export const useComposable = (define: AIStatementProps) => {
    //* 插件
    const i18n = useI18n();
    const router = useRouter();

    //* 响应式变量
    const refs = {
        show: ref<boolean>(define.visible),
        data: reactive({ context: "" }),
        rules: ref<{ [name: string]: UiTypes.verifyRule[] }>({
            opinion: [
                {
                    trigger: "change",
                    verify: (value: any) => {
                        return { verify: value.context, message: i18n.t("Placeholder.ThisFieldRequired") };
                    },
                },
            ],
        }),
    };

    //* 节点
    const nodes = {
        modal: ref<InstanceType<typeof UiModal>>(),
        form: ref<InstanceType<typeof UiForm>>(),
    };

    //* 表单函数列表
    const methods = {
        submit: () => {
            nodes.form.value?.validator((valid: any) => {
                if (!valid) return;

                const params = {
                    path: router.currentRoute.value.path,
                    type: define.type,
                    type_id: router.currentRoute.value.params?.id || "",
                    plate_name: define.name || "",
                    text: define.contexts.origin,
                    translate: define.contexts.default,
                    comment: refs.data.context,
                };

                api.frontend("/api/v1/feedback/translate-ai", {
                    method: "POST",
                    data: params,
                    headers: {
                        "x-client-uid": get_canvas_fingerprint(),
                    },
                    success: (response: any) => {
                        $message.success(i18n.t("ContactUs.Success"));
                        refs.data.context = "";
                        nodes.form.value?.reset();
                        //* 1.5秒后关闭弹窗 
                        setTimeout(() => {
                            nodes.modal.value?.closeModal();
                        }, 800);
                    },
                });
            });
        },
    };

    //* 计算属性
    const computeds = {
        spacing: computed(() => `${define.spacing?.y || 40}px ${define.spacing?.x || 56}px`),
        inputLength: computed(() => {
            return refs.data.context.length;
        }),
    };

    //* 属性
    const binds = {
        //* 内容
        content: {
            style: {
                padding: computeds.spacing.value,
            },
        },
    };

    //* 动画函数列表
    const animations = {
        //* 入场前动画
        entrancePre: (el: Element) => {
            gsap.set(el, { marginTop: 0, padding: `0 ${define.spacing?.x || 56}px`, opacity: 0 });
            gsap.set(el.querySelector(".ai-statement-context"), { height: 0 });
        },

        //* 入场动画
        entrance: (el: Element, done: () => void) => {
            gsap.to(el.querySelector(".ai-statement-context"), { duration: 0.4, height: "auto" });
            gsap.to(el, {
                marginTop: 16,
                duration: 0.4,
                padding: computeds.spacing.value,
                opacity: 1,
                ease: ">",
                onComplete: () => done(),
            });
        },

        //* 离场动画
        departure: (el: Element, done: () => void) => {
            gsap.to(el.querySelector(".ai-statement-context"), { duration: 0.4, height: 0 });
            gsap.to(el, {
                marginTop: 0,
                duration: 0.4,
                padding: `0 ${define.spacing?.x || 56}px`,
                opacity: 0,
                ease: ">",
                onComplete: () => done(),
            });
        },
    };

    return { refs, nodes, binds, animations, methods, computeds };
};
